import styles from '../styles/components/waitPaidInvoice.module.css';
import Modal from './Modal';
import { StoreContext } from '..';
import { useContext, useEffect } from 'react';
import paymentService from "../services/payment";
import Spinner from './Spinner';


interface ComponentProps {
    cancel: Function;
    invoiceId: number;
};


export default function WaitPaidInvoice({cancel, invoiceId}: ComponentProps) {
    const tg = window.Telegram.WebApp;
    const {appStore} = useContext(StoreContext);
    
    const cancelWithError = () => {    
        appStore.addError("При подтверждении оплаты произошла ошибка. Пожалуйста, подождите. В случае сохранения ошибки обратитесь в техническую поддержку");
        cancel();
    };

    const cancelModal = () => {
        tg.HapticFeedback.impactOccurred("light");
        cancel();
    };

    useEffect(() => {
        let intervalId = null as any;

        const effect = async () => {
            intervalId = setInterval(async () => {
                try {
                    const response = await paymentService.getInvoice(invoiceId);

                    if (response.status === 200) {
                        const invoice = response.data.invoice;

                        if (invoice.paided) {

                            // Ушел от этого кода, пришел просто к обновлению данных юзера
                            // if (invoice.product_type === "promocoin") {
                            //     appStore.user.balance += invoice.product_value;
                            // }
                            // else if (invoice.product_type === "subscriptions") {
                            //     appStore.user.limit = config.subsLimit;
                            //     appStore.user.next_recovery = null;
                            // };

                            // На всякий обрабатываем, чтобы пользователь понял, что оплата прошла
                            try {
                                await appStore.getUser();
                                await appStore.getDayPromoCode();
                            } catch { }
                            tg.HapticFeedback.notificationOccurred("success");
                            cancel(true);  // true потому что success, чтобы штуку с оффером закрыло
                        };
                    } else {
                        cancelWithError();
                    };
                } catch {
                    cancelWithError();
                };
            }, 3000);
        };

        effect();

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            };
        };
    }, []);
    
    return <Modal cancel={cancelModal} style={{minHeight: "150px"}} zIndex={102}>
        <h1>Подтвержение оплаты</h1>
        <div className={styles.spinner_wrapper}><Spinner/></div>
    </Modal>;
};